/**
 * Auth Page
 *
 * @author edmsamuel
 */
import React from 'react';
import { Divider } from 'antd';
import { Redirect } from 'react-router';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import Login from '../components/Login';
import { FLAG_LOCAL_STORAGE_TOKEN } from '../Flags';
import { Panel } from '../components';
import Api from '../Api';
import { OrgConsumer } from '../context/Organizacion';
import { buildPath } from '../Routes';
import { appAccountSet } from '../actions/cuenta';
import ChatwootWidget from '../components/chatwoot';

class Page extends React.Component {
  /**
   * OnLoginOk
   *
   * @param {Object} usuario
   */
  onLoginOk = (usuario) => {
    Api.setUserData(usuario)
    this.props.setAccount(usuario)
    this.props.goToNext(
      usuario.needsChangePassword ?
        '/preferencias' :
        '/'
    );
  }

  /**
   * Render
   */
  render() {
    if (localStorage.getItem(FLAG_LOCAL_STORAGE_TOKEN) != null) {
      return <Redirect to={buildPath('/')} />;
    }

    const { theme } = this.props

    return (
      <OrgConsumer>
        {org => (
          <div className='administrar clear container secondary'>
            <div className={`content clear left right bottom padded ${this.props.mode}`} style={styles.content}>
              <Panel style={styles.form}>
                <h3 style={styles.header}>
                  <img src={Api.to('/cmr/organizacion/image-file/imagen')} alt='app' height={35} />
                  <Divider type='vertical'/>
                  <span style={{ color: theme.colors.text }}>{org.nombre}</span>
                </h3>
                <Login onLoginOk={this.onLoginOk} />
              </Panel>
            </div>

            <ChatwootWidget />
          </div>
        )}
      </OrgConsumer>
    );
  }
}

const styles = {
  content: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  form: {
    maxWidth: 425,
    maxHeight: 500,
    padding: 20,
    borderRadius: 4
  },
  header: {
    marginBottom: 20
  }
};

export default connect(
  state => ({ theme: state.theme.values }),
  dispatch => ({
    setAccount: (data) => dispatch(
      appAccountSet(data)
    ),
    goToNext: (customPath) => dispatch(
      push(buildPath(customPath || '/'))
    )
  })
)(Page);
